import { render, staticRenderFns } from "./endereco.vue?vue&type=template&id=0329732c"
import script from "./endereco.ts?vue&type=script&lang=js&external"
export * from "./endereco.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0329732c')) {
      api.createRecord('0329732c', component.options)
    } else {
      api.reload('0329732c', component.options)
    }
    module.hot.accept("./endereco.vue?vue&type=template&id=0329732c", function () {
      api.rerender('0329732c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/resumo/endereco.vue"
export default component.exports